// ============================================================================
// Operador de banderas (épica #1219) — quién ve y usa la app Feature Flags.
// ============================================================================
// Contrato compartido por las cuatro plataformas: opera banderas el admin de
// plataforma, el owner y el developer (id fijo `developer`, #1213). El admin de
// una empresa cliente NO.
//
// El front de WAYAK decide "admin de plataforma" por id (`TOP_ROLE_IDS`, igual
// que el resto de sus gates): sólo PRESENTA. La autoridad es el backend
// (`requireFlagsOperator`), que además lee `roles/{id}.platform_admin`.
// ============================================================================
import { useUserStore } from "../store/userStore";
import { TOP_ROLE_IDS } from "./useIsReseller";

/** Rol de desarrollo: id fijo, igual en CC-CONSOLE, WAYAK, NUVEX y AgroCloud. */
export const DEVELOPER_ROLE_ID = "developer";

/** Roles que operan banderas: owner, admin reseller y developer. */
export const FLAGS_OPERATOR_ROLE_IDS: string[] = [...TOP_ROLE_IDS, DEVELOPER_ROLE_ID];

/** ¿El rol opera banderas? */
export const isFlagsOperatorRoleId = (roleId?: string | null): boolean =>
  !!roleId && FLAGS_OPERATOR_ROLE_IDS.includes(roleId);

/** ¿El rol es developer (y no además admin de plataforma)? */
export const isDeveloperRoleId = (roleId?: string | null): boolean => roleId === DEVELOPER_ROLE_ID;

const storedRoleId = (): string | null => {
  try {
    return localStorage.getItem("userRoleId");
  } catch {
    return null;
  }
};

/** Rol de la sesión: el del store reactivo, o el de localStorage al arrancar. */
export function useSessionRoleId(): string | null {
  const roleId = useUserStore((state) => state.user?.role_id);
  return roleId ?? storedRoleId();
}

/** ¿La sesión actual opera banderas? */
export function useIsFlagsOperator(): boolean {
  return isFlagsOperatorRoleId(useSessionRoleId());
}

export default useIsFlagsOperator;
